// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_aee9e1f","marketTemplateWrapper":"_7e06e14"};